export default __webpack_public_path__ + "static/media/MAF.9d4ba6ea.svg";